import FacilityManagement from './FacilityManagement';
export default FacilityManagement;
